import { render, staticRenderFns } from "./DialogAdditionalAgreement.vue?vue&type=template&id=5c9c51fa"
import script from "./DialogAdditionalAgreement.vue?vue&type=script&lang=js"
export * from "./DialogAdditionalAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports